import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import withRouter from "@velzon/components/withRouter.js";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";

import {
  changeLayout,
  changeSidebarTheme,
  changeLayoutMode,
  changeLayoutWidth,
  changeLayoutPosition,
  changeTopBarTheme,
  changeLeftSidebarSizeType,
  changeLeftSidebarViewType,
  changeSidebarImageType
} from "store/reducer/LayoutSlice/index.js";
import Sidebar from "./Sidebar.js";
import Header from "./Headers/Header.js";

// Memoized selector to avoid unnecessary re-renders
const selectLayoutSettings = createSelector(
  (state) => state.Layout,
  (Layout) => ({
    layoutType: Layout.layoutType,
    leftSidebarType: Layout.leftSidebarType,
    layoutModeType: Layout.layoutModeType,
    layoutWidthType: Layout.layoutWidthType,
    layoutPositionType: Layout.layoutPositionType,
    topBarThemeType: Layout.topBarThemeType,
    leftSideBarSizeType: Layout.leftSideBarSizeType,
    leftSidebarViewType: Layout.leftSidebarViewType,
    leftSidebarImageType: Layout.leftSidebarImageType
  })
);

const Layout = (props) => {
  const [headerClass, setHeaderClass] = useState("");
  const dispatch = useDispatch();

  const {
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topBarThemeType,
    leftSideBarSizeType,
    leftSidebarViewType,
    leftSidebarImageType
  } = useSelector(selectLayoutSettings);

  /*
    layout settings
  */
  useEffect(() => {
    if (
      layoutType ||
      leftSidebarType ||
      layoutModeType ||
      layoutWidthType ||
      layoutPositionType ||
      topBarThemeType ||
      leftSideBarSizeType ||
      leftSidebarViewType ||
      leftSidebarImageType
    ) {
      dispatch(changeLeftSidebarViewType(leftSidebarViewType));
      dispatch(changeLeftSidebarSizeType(leftSideBarSizeType));
      dispatch(changeSidebarTheme(leftSidebarType));
      dispatch(changeLayoutMode(layoutModeType));
      dispatch(changeLayoutWidth(layoutWidthType));
      dispatch(changeLayoutPosition(layoutPositionType));
      dispatch(changeTopBarTheme(topBarThemeType));
      dispatch(changeLayout(layoutType));
      dispatch(changeSidebarImageType(leftSidebarImageType));
    }
  }, [
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topBarThemeType,
    leftSideBarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
    dispatch
  ]);

  /*
    call dark/light mode
  */
  const onChangeLayoutMode = useCallback(
    (value) => {
      if (changeLayoutMode) {
        dispatch(changeLayoutMode(value));
      }
    },
    [dispatch]
  );

  useEffect(() => {
    const scrollNavigation = () => {
      let scrollUp = document.documentElement.scrollTop;
      if (scrollUp > 50) {
        setHeaderClass("topbar-shadow");
      } else {
        setHeaderClass("");
      }
    };

    window.addEventListener("scroll", scrollNavigation, true);
    return () => {
      window.removeEventListener("scroll", scrollNavigation, true);
    };
  }, []);

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header
          headerClass={headerClass}
          layoutModeType={layoutModeType}
          onChangeLayoutMode={onChangeLayoutMode}
        />
        <Sidebar layoutType={layoutType} />
        <div className="main-content">{props.children}</div>
      </div>
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.any
};

export default withRouter(Layout);
